import React, { useEffect, useState } from "react";
import styles from "./ChargesPage.module.css";

const API_URL = process.env.REACT_APP_API_URL;

const AdminCharges = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchUpdateSummary = async () => {
      try {
        const response = await fetch(`${API_URL}/chargesUpdated`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(data.error || "Failed to update charges.");
        }

        setResult(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUpdateSummary();
  }, []);

  if (loading) return <div className={styles.message}>Loading update summary...</div>;
  // if (error) return <div className={styles.error}>Error: {error}</div>;
  if (!result) return null;

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Charges Rate Update Summary</h1>

      <div className={styles.item}>
        <div className={styles.label}>Total Data In Charges Table</div>
        <div className={styles.value}>{result.totalCharges.toLocaleString()}</div>
      </div>

      <div className={styles.item}>
        <div className={styles.label}>File Data Matched In Charges</div>
        <div className={styles.value}>{result.matchedCharges.toLocaleString()}</div>
      </div>

      <div className={styles.item}>
        <div className={styles.label}>Updated Charges Table Count</div>
        <div className={styles.value}>{result.updatedCharges.toLocaleString()}</div>
      </div>

      <div className={styles.item}>
        <div className={styles.label}>Skipped Charges Table Count</div>
        <div className={styles.value}>{result.skippedCharges.toLocaleString()}</div>
      </div>
    </div>
  );
};

export default AdminCharges;
